var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 1.25H5.625C4.58947 1.25 3.75 2.08947 3.75 3.125V16.875C3.75 17.9105 4.58947 18.75 5.625 18.75H14.375C15.4105 18.75 16.25 17.9105 16.25 16.875V3.125C16.25 2.08947 15.4105 1.25 14.375 1.25Z",
    stroke: "#737373",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.125H11.875",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0264 11.1136C12.879 10.9565 12.7004 10.832 12.5021 10.7478C12.3038 10.6637 12.0902 10.6218 11.8748 10.6249C11.4217 10.6249 11.0119 10.7972 10.7209 11.1105C10.4299 11.4237 10.2834 11.8573 10.317 12.3214C10.3838 13.2386 11.0826 13.9843 11.8748 13.9843C12.667 13.9843 13.3647 13.2386 13.4322 12.3222C13.4666 11.862 13.3221 11.4327 13.0264 11.1136ZM14.519 17.4999H9.23068C9.16184 17.501 9.09359 17.487 9.03076 17.4589C8.96792 17.4307 8.91202 17.3891 8.86701 17.337C8.8182 17.2786 8.78317 17.2099 8.76451 17.136C8.74584 17.0622 8.74403 16.9851 8.7592 16.9105C8.88615 16.2245 9.28185 15.6484 9.90373 15.2441C10.4561 14.8851 11.1561 14.6874 11.8748 14.6874C12.5936 14.6874 13.2936 14.8851 13.8459 15.2441C14.4678 15.6484 14.8635 16.2245 14.9904 16.9105C15.0056 16.9851 15.0038 17.0622 14.9851 17.136C14.9665 17.2099 14.9314 17.2786 14.8826 17.337C14.8376 17.3891 14.7817 17.4307 14.7189 17.4589C14.656 17.487 14.5878 17.501 14.519 17.4999Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.64a5e9bf6889064da872f88a5d02b30f.svg";
export { ForwardRef as ReactComponent };